import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { Container, Card, Form, Button, Spinner, Alert, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function SystemSettings() {
  const [settings, setSettings] = useState({
    orderChangeTimeLimit: 30,
    deliveryDeadline: '15:00',
    orderChangeDeadlineTime: '14:45',
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const settingsDocRef = doc(db, 'system_settings', 'config');

  useEffect(() => {
    document.title = 'システム設定 | My Order System';
    const fetchSettings = async () => {
      try {
        const docSnap = await getDoc(settingsDocRef);
        if (docSnap.exists()) {
          setSettings(prev => ({ ...prev, ...docSnap.data() }));
        } else {
          await setDoc(settingsDocRef, settings);
        }
      } catch (err) {
        setError('設定の読み込みに失敗しました。');
        console.error(err);
      }
      setLoading(false);
    };
    fetchSettings();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    setError('');
    setSuccess('');
    try {
      await setDoc(settingsDocRef, settings, { merge: true });
      setSuccess('設定を保存しました。');
    } catch (err) {
      setError('設定の保存に失敗しました。');
      console.error(err);
    }
    setSaving(false);
  };

  if (loading) {
    return (
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{ height: '100vh' }}
      >
        <Spinner animation="border" />
      </Container>
    );
  }

  return (
    <main>
      <Container className="my-4">
        <Card className="shadow-sm">
          <Card.Header as="h2" className="p-3">
            システム設定
          </Card.Header>
          <Card.Body className="p-4">
            {error && <Alert variant="danger">{error}</Alert>}
            {success && <Alert variant="success">{success}</Alert>}
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      オーダー変更期限 (分)
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="orderChangeTimeLimit"
                      value={settings.orderChangeTimeLimit}
                      onChange={handleChange}
                      min="1"
                      step="1"
                      placeholder="例: 30"
                    />
                    <Form.Text className="text-muted">
                      注文後、ここで設定した分数以内であれば変更が可能です。
                    </Form.Text>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      当日配送締切時間
                    </Form.Label>
                    <Form.Control
                      type="time"
                      name="deliveryDeadline"
                      value={settings.deliveryDeadline}
                      onChange={handleChange}
                    />
                    <Form.Text className="text-muted">
                      この時刻までの注文が当日配送の対象となります。
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              {/* 【変更点】新しい設定項目を追加 */}
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      オーダー変更受付締切時間
                    </Form.Label>
                    <Form.Control
                      type="time"
                      name="orderChangeDeadlineTime"
                      value={settings.orderChangeDeadlineTime}
                      onChange={handleChange}
                    />
                    <Form.Text className="text-muted">
                      この時刻を過ぎると、注文直後でも変更・キャンセルができなくなります。
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              <div className="d-grid mt-3">
                <Button
                  variant="primary"
                  onClick={handleSave}
                  disabled={saving}
                >
                  {saving ? <Spinner as="span" size="sm" /> : '設定を保存'}
                </Button>
              </div>
            </Form>
            <hr className="my-4" />
            <Link to="/admin">
              管理者メニューに戻る
            </Link>
          </Card.Body>
        </Card>
      </Container>
    </main>
  );
}

export default SystemSettings;
